import { Box } from "@chakra-ui/react";
import { Button, Modal, Typography } from "antd";
import moment from "moment";
import { useCallback, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useAccountDeletion } from "./AccountDeletion";

const { Text } = Typography;

const CancelDeletion = ({
    deletionDate,
    onConfirm,
    immediately
}: {
    deletionDate?: string | null,
    onConfirm: () => Promise<void>,
    immediately: boolean
}) => {
    const [, setSearchParams] = useSearchParams();
    const { cancelDeletion: {
        mutateAsync: cancelAccountDeletion,
        isLoading
    } } = useAccountDeletion(false);

    const cancel = useCallback(async () => {
        await cancelAccountDeletion();
        await onConfirm();
        setSearchParams({});
        Modal.info({
            title: "Account Deletion Cancelled",
            content: (<Box>
                Your account is no longer scheduled to be deleted.
            </Box>)
        });
    }, [cancelAccountDeletion, onConfirm, setSearchParams]);

    useEffect(() => {
        if (immediately) {
            cancel();
        }
    }, [immediately, cancel])

    return <>
        <Text type="danger" strong>Account will be deleted on {moment(deletionDate).format('MM/DD/YYYY LT')}</Text>
        <Button block type="primary" onClick={async () => { await cancel(); }} loading={isLoading}>Cancel Account Deletion</Button>
    </>;
}

export default CancelDeletion;